import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import Seo from "@/components/feature/Seo";
import HeroSection from "./components/HeroSection";
import TrendingSection from "./components/TrendingSection";
import CategorySection from "./components/CategorySection";
import FeaturedFeed from "./components/FeaturedFeed";
import SubmitProcessSection from "./components/SubmitProcessSection";
import FaqSection from "./components/FaqSection";
import TestimonialSection from "./components/TestimonialSection";
import { faqs } from "@/mocks/site";

const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "瓜友会网",
    url: "https://jfinger.cn",
    description:
      "瓜友会网是面向中文互联网的匿名爆料与投稿社区，提供线索征集、独家消息投稿与热门瓜料聚合。",
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://jfinger.cn/hot?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "瓜友会网",
    url: "https://jfinger.cn",
    email: "tougao@guayouhui.com",
    description: "匿名爆料与线索征集社区，全天候接收投稿并保护投稿者隐私。",
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  },
];

export default function Home() {
  return (
    <>
      <Seo
        title="瓜友会网 | 匿名爆料与投稿入口，独家消息等你来投"
        description="瓜友会网开通匿名爆料与投稿入口，专注线索征集与独家消息收集，全程保护投稿者隐私。手里有料不敢说？24 小时开放的投稿通道，让你的线索被更多人看见。"
        keywords="瓜友会网,匿名爆料,投稿入口,独家消息,线索征集"
        path="/"
        jsonLd={homeJsonLd}
      />
      <SiteHeader />
      <main>
        <HeroSection />
        <TrendingSection />
        <CategorySection />
        <FeaturedFeed />
        <SubmitProcessSection />
        <FaqSection />
        <TestimonialSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}